import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const Footer = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleHomeClick = (e) => {
    e.preventDefault();
    
    if (location.pathname === '/') {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      navigate('/');
      setTimeout(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }, 100);
    }
  };

  return (
    <footer className="bg-rose-100 text-white py-8 md:py-10 lg:py-12">
      {/* Main Footer Content */}
      <div className="max-w-7xl mx-auto px-4 grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-8">
        
        {/* Left Column - Brand */}
        <div className="md:col-span-5 text-center md:text-left">
          <h3 
          className="text-2xl md:text-3xl font-display font-bold text-rose-400 mb-2 md:mb-3"
          style={{ fontFamily: 'Great Vibes, cursive' }}
          >
            Dear Bea.
          </h3>
          <p className="text-gray-400 mb-3 md:mb-4 font-sans leading-snug text-xs md:text-sm max-w-sm mx-auto md:mx-0">
            Handcrafted ribbon roses and fresh flower arrangements for every special occasion.
          </p>
          <div className="flex gap-3 md:gap-4 justify-center md:justify-start">
            <a 
              href="https://instagram.com/dearbea.flowers" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-gray-400 hover:text-rose-400 transition"
              aria-label="Instagram"
            >
              <svg className="w-5 h-5 md:w-6 md:h-6" fill="currentColor" viewBox="0 0 24 24">
                <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
              </svg>
            </a>
            <a 
              href="https://tiktok.com/@dearbea.flowers" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-gray-400 hover:text-rose-400 transition"
              aria-label="TikTok"
            >
              <svg className="w-5 h-5 md:w-6 md:h-6" fill="currentColor" viewBox="0 0 24 24">
                <path d="M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-5.2 1.74 2.89 2.89 0 012.31-4.64 2.93 2.93 0 01.88.13V9.4a6.84 6.84 0 00-1-.05A6.33 6.33 0 005 20.1a6.34 6.34 0 0010.86-4.43v-7a8.16 8.16 0 004.77 1.52v-3.4a4.85 4.85 0 01-1-.1z"/>
              </svg>
            </a>
          </div>
        </div>

        {/* Middle Column - Quick Links */}
        <div className="md:col-span-3 text-center md:text-left">
          <h4 className="text-lg md:text-xl font-semibold mb-3 md:mb-4 font-display">Quick Links</h4>
          <ul className="space-y-2 md:space-y-3 font-sans text-sm md:text-base">
            <li>
              <button 
                onClick={handleHomeClick}
                className="text-gray-400 hover:text-rose-400 transition cursor-pointer"
              >
                Home
              </button>
            </li>
            <li>
              <button 
                onClick={() => navigate('/contact')}
                className="text-gray-400 hover:text-rose-400 transition cursor-pointer"
              >
                Contact
              </button>
            </li>
            <li>
              <button 
                onClick={() => navigate('/cart')}
                className="text-gray-400 hover:text-rose-400 transition cursor-pointer"
              >
                Cart
              </button>
            </li>
            <li>
            <button
              onClick={() => navigate('/terms')}
              className="text-gray-400 hover:text-rose-400 transition cursor-pointer"
              >
                Terms & Conditions</button>
            </li>
          </ul>
        </div>

        {/* Right Column - Contact */}
        <div className="md:col-span-4 text-center md:text-left">
          <h4 className="text-lg md:text-xl font-semibold mb-3 md:mb-4 font-display">Contact</h4>
          <p className="text-gray-400 mb-2 md:mb-3 font-sans text-sm md:text-base">Sydney NSW</p>
          <p className="text-gray-400 font-sans text-xs md:text-sm break-words px-2 md:px-0">
            Email:{' '}
            <a 
              href="mailto:dearbea.flowers@gmail.com"
              className="hover:text-rose-400 transition"
            >
              dearbea.flowers@gmail.com
            </a>
          </p>
        </div>
      </div>

      {/* Copyright */}
      <div className="max-w-7xl mx-auto px-4 mt-6 md:mt-8 pt-4 md:pt-6 border-t border-gray-800 text-center">
        <p className="text-gray-400 text-xs md:text-sm font-sans">
          © {new Date().getFullYear()} Dear Bea. All rights reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;